import React, { useState, useEffect } from 'react';
import apiService from '../services/api.service';

const ConnectorDetailsModal = ({ isOpen, onClose, connectorId, initialData, onSave }) => {
    const [formData, setFormData] = useState({ name: '', email: '', address: '' });
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (isOpen && initialData) {
            setFormData({
                name: initialData.name || '',
                email: initialData.email || '',
                address: initialData.address || ''
            });
        }
    }, [isOpen, initialData]);

    const handleSave = async () => {
        setSaving(true);
        try {
            const response = await apiService.post('/as2/connectors/details', {
                connectorId,
                ...formData
            });
            if (response.success) {
                if (onSave) onSave();
                onClose();
            } else {
                alert('Failed to save details');
            }
        } catch (err) {
            console.error('Error saving connector details:', err);
            alert('Error saving details');
        } finally {
            setSaving(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" style={{ zIndex: 1001 }}>
            <div className="modal-content">
                <h2>Edit Connector Details</h2>
                <div className="form-group">
                    <label>Friendly Name</label>
                    <input
                        type="text"
                        value={formData.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        placeholder="e.g., My Trading Partner"
                    />
                </div>
                <div className="form-group">
                    <label>Email</label>
                    <input
                        type="email"
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        placeholder="contact@partner.com"
                    />
                </div>
                <div className="form-group">
                    <label>Address</label>
                    <textarea
                        value={formData.address}
                        onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                        placeholder="123 Partner Way..."
                    />
                </div>
                <div className="modal-actions">
                    <button className="cancel-btn" onClick={onClose} disabled={saving}>Cancel</button>
                    <button className="save-btn" onClick={handleSave} disabled={saving}>
                        {saving ? 'Saving...' : 'Save Details'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConnectorDetailsModal;
